import { render, staticRenderFns } from "./DsfrAccordion.vue?vue&type=template&id=8502cdca&"
import script from "./DsfrAccordion.vue?vue&type=script&lang=js&"
export * from "./DsfrAccordion.vue?vue&type=script&lang=js&"
import style0 from "./DsfrAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports